import { action } from 'satcheljs/lib/legacy';
import { FeedbackViewState } from '../store/schema/FeedbackViewState';

export default action('setClassificationState')(function setClassificationState(
    state: FeedbackViewState,
    classification: string
) {
    state.classification = state.classification == classification ? '' : classification;
});
